import { selectFromCompletedRoutesInsightsOverTimeDto } from '../../models';

const InsightsQueryOverTime = selectFromCompletedRoutesInsightsOverTimeDto()
  .completedRoutes(r => r
    .value
    .interval,
  )
  .completedOrders(o => o
    .value
    .interval,
  )
  .completedWorkingTime(wt => wt
    .value
    .interval,
  )
  .estimatedDistanceCompleted(d => d
    .value
    .interval,
  )
  .toString();

export default InsightsQueryOverTime;
